<template>
  <div>
    <!-- Title -->
    <h4 class="text-primary text-center mb-2">
      <i class="fa-solid fa-rocket"></i>
      {{ $t('tabs.titanAccounts.details') }}
    </h4>

    <!-- General Information -->
    <b-card class="mb-1">
      <b-card-title>{{ $t('columns.generalInfo') }}</b-card-title>
      <b-row>
        <b-col cols="12" md="6">
          <label>{{ $t('columns.name') }}</label>
          <b-form-input v-model="titan.name" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.accountId') }}</label>
          <b-form-input v-model="titan.accountId" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.usageType') }}</label>
          <v-select v-model="titan.usageType" :options="usageTypeOptions" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.status') }}</label>
          <v-select v-model="titan.status" :options="statusOptions" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.campaignType') }}</label>
          <b-form-input v-model="titan.campaignType" />
        </b-col>

        <b-col cols="12" md="6">
          <label>{{ $t('columns.orgId') }}</label>
          <organization-select-box v-model="titan.orgId"/>
        </b-col>


        <b-col cols="12">
          <label>{{ $t('columns.notes') }}</label>
          <b-form-textarea v-model="titan.notes" rows="3" />
        </b-col>
      </b-row>
    </b-card>

    <!-- Actions -->
    <div class="text-center mt-2">
      <b-button size="sm" variant="outline-warning" @click="reset">
        {{ $t('operations.reset') }}
      </b-button>
      &nbsp;
      <b-button size="sm" variant="outline-success" @click="save">
        {{ $t('operations.save') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import Titan from '@/model/campaign/Titan'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import { mapActions } from 'vuex'
import OrganizationSelectBox from '@/components/widget/select/OrganizationSelectBox.vue';

export default {
  name: 'TitanEditDetails',
  components: { OrganizationSelectBox },
  mixins: [mixinNotifications, mixinPermissions],
  data() {
    return {
      titan: Titan(),
      usageTypeOptions: [
        'Marketing',
        'Sales',
        'Analytics',
        'Testing',
        'Other'
      ],
      statusOptions: [
        'Active',
        'Inactive',
        'Pending',
        'Archived',
        'Error'
      ]
    }
  },
  props: {
    value: { type: Object, default: () => ({}) }
  },
  watch: {
    value: {
      handler(val) {
        this.titan = Object.assign(Titan(), val)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('titan', ['createTitan', 'updateTitan']),
    async save() {
      if (!this.titan.id) {
        await this.createTitan({ titan: this.titan })
        this.showSuccessNotification(
            this.$t('globalMessages.addDataSuccess', { system: this.$t('menu.titanAccounts') })
        )
      } else {
        await this.updateTitan({ titan: this.titan, id: this.titan.id })
        this.showSuccessNotification(
            this.$t('globalMessages.updateDataSuccess', { system: this.$t('menu.titanAccounts') })
        )
      }
      this.refreshTables();

      this.$emit('input', this.titan)
      this.$emit('close')
    },
    reset() {
      this.titan = Titan()
    }
  }
}
</script>
